import React, {useState} from "react";
import { BottomNavigation,
    BottomNavigationAction,
    makeStyles,
    SvgIcon,
    Drawer,
    List,
    ListItem,
} from "@material-ui/core";
import {ReactComponent as HomeSVG} from "../../Images/home.svg";
import {ReactComponent as HeartSVG} from "../../Images/heart.svg";
import {ReactComponent as MenuSVG} from "../../Images/three-dots.svg";
import {ReactComponent as CalendarSVG} from "../../Images/calendar3.svg";
import { colorWhite } from "../../Constants/theme";
import { useHistory, useLocation } from "react-router";
import Navigation from "../Navigation";
import { useEffect } from "react";

const useStyles = makeStyles({
    root: {
        width: "100%",
        zIndex: 999,
        position: "fixed",
        left: 0,
        bottom: 0,
        backgroundColor: colorWhite,
        boxShadow: "0 0 2px 0 rgba(27, 111, 166, 0.5)",
        padding: "5px 30px",
        borderTop: "1px solid #FAFAFA",
        // display: "flex",
        // flexDirection: "row",
        // alignItems: "center",
        // justifyContent: "space-between",
        // borderBottomColor: "#E5E6F2",
        height: "65px",
    },
    list: {
        width: 250,
        zIndex: 9999,
	  },
	  fullList: {
        width: "auto",
	  },
    navItem: {
        minWidth: 94
    }
});

const BottomNav = () => {
    const classes = useStyles();
    const history = useHistory();
    const [value, setValue] = useState("schedule");
    const [open, setOpen] = useState(false);
    const [role, setRole] = useState("");
    const location = useLocation();
    const [hideNav, setHideNav] = useState(true);

    const toggleDrawer = (status: boolean) => (
		event: React.KeyboardEvent | React.MouseEvent,
	  ) => {
        if (
            event.type === "keydown" &&
			((event as React.KeyboardEvent).key === "Tab" ||
			(event as React.KeyboardEvent).key === "Shift")
        ){
            return;
        }
        setOpen(status);
    };

    useEffect(() => {
        if (open) {
            setOpen(false);
        }
        if (location.pathname === "/schedule"){
            setValue("schedule");
        } else 	if (location.pathname === "/appointments"){
            setValue("appointments");
        } else if (location.pathname === "/pets"){
            setValue("pets");
        }

        if (["login", "signUp", "welcome", "forgotPassword", "chat", "gettingStarted"].some(item => location.pathname.includes(item))){
            setHideNav(true);
        }else{
            setHideNav(false);
            setRole(JSON.parse(localStorage.getItem("auth"))?.role);
        }
    }, [location]);

    const handleChange = (event: React.ChangeEvent<{}>, newValue: string) => {
        if (newValue !== "more") {
            setValue(newValue);
            history.push(`/${newValue}`);
        }else if (newValue === "more"){
            setOpen(true);
        }
    };

    return (
        <>
            {!hideNav &&
				<>
				    <BottomNavigation value={value} onChange={handleChange} showLabels className={classes.root}>
				        {role === "OWNER" &&
                        <BottomNavigationAction label="Schedule" value="schedule" icon={<SvgIcon component={HomeSVG} viewBox="0 0 22 22" height="24px" width="24px" />} />}
				        {role === "OWNER" &&
                        <BottomNavigationAction label="Pets" value="pets" icon={<SvgIcon component={HeartSVG} viewBox="0 0 17 17" height="24px" width="24px" />} />}
				        <BottomNavigationAction label="Appointments" classes={{root: classes.navItem}} value="appointments" icon={<SvgIcon component={CalendarSVG} viewBox="0 0 17 17" height="24px" width="24px" />} />
				        <BottomNavigationAction label="More" value="more" icon={<SvgIcon component={MenuSVG} viewBox="0 0 16 16" height="24px" width="24px" />} />
				    </BottomNavigation>
				    <Drawer anchor="right" open={open} onClose={toggleDrawer(false)}>
				        <div className={classes.list}>
				            <Navigation />
				        </div>
				    </Drawer>
				</>
            }
        </>
    );
};

export default BottomNav;
